import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=0b8e8fda"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Dev\\WorldManager\\src\\WorldManager.Web\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b8e8fda')) {
      api.createRecord('0b8e8fda', component.options)
    } else {
      api.reload('0b8e8fda', component.options)
    }
    module.hot.accept("./Home.vue?vue&type=template&id=0b8e8fda", function () {
      api.rerender('0b8e8fda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/eventTimetable/Home.vue"
export default component.exports